import { Button, HStack } from "@chakra-ui/react"

type SortButtonsProps = {
  sortKey: string
  sortOrder: string
  onSortChange: (key: string, order: string) => void
}

export default function SortButtons({ sortKey, sortOrder, onSortChange }: SortButtonsProps) {
  const toggleSort = (key: string) => {
    if (sortKey === key) {
      const newOrder = sortOrder === "asc" ? "desc" : "asc"
      onSortChange(key, newOrder)
    } else {
      onSortChange(key, "desc")
    }
  }

  return (
    <HStack gap={2}>
      <Button
        px={3}
        py={1}
        borderRadius="md"
        onClick={() => toggleSort("created_at")}
      >
        생성일 {sortKey === "created_at" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
      </Button>
      <Button
        px={3}
        py={1}
        borderRadius="md"
        onClick={() => toggleSort("report_job_name")}
      >
        이름 {sortKey === "report_job_name" ? (sortOrder === "asc" ? "↑" : "↓") : ""}
      </Button>
    </HStack>
  )
}
